module.exports = __webpack_public_path__ + "static/media/pandaria-1.47643e5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/pandaria-1.jpg
// module id = 103
// module chunks = 0